import { dayInMilliseconds } from 'utils/utils';

export const DEFAULT_CALENDAR_DAYS_FROM_TODAY = 7;
export const HOTEL_ONLY_MAXIMUM_DURATION = 30;
export const MINIMUM_DAYS_FOR_PRICE_MATCH = 14;
export const DEFAULT_HOTEL_ONLY_DURATION = 7;
export const HOTEL_ONLY_INDEX_MAX_SUPPORTED_DAYS = 15;

const dateWords = {
  ddd: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat'.split(','),
  MMMM: 'January,February,March,April,May,June,July,August,September,October,November,December'.split(','),
  MMM: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec'.split(','),
};

const formatTokens = {
  ddd: date => dateWords.ddd[date.getDay()],
  D: date => date.getDate(),
  DD: date => `0${date.getDate()}`.substr(-2),
  M: date => `${date.getMonth() + 1}`,
  MM: date => `0${date.getMonth() + 1}`.substr(-2),
  MMM: date => dateWords.MMM[date.getMonth()],
  MMMM: date => dateWords.MMMM[date.getMonth()],
  YY: date => `${date.getFullYear()}`.substr(-2),
  YYYY: date => date.getFullYear(),
  HH: date => `0${date.getHours()}`.substr(-2),
  mm: date => `0${date.getMinutes()}`.substr(-2),
  ss: date => `0${date.getSeconds()}`.substr(-2),
};

const dateFormatRegEx = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

export default {
  format(dateOrTimestamp, format) {
    let date;

    if (dateOrTimestamp) {
      date = dateOrTimestamp instanceof Date ? dateOrTimestamp : this.utcDate(dateOrTimestamp);
    } else {
      date = this.utcDate();
    }

    return format.replace(dateFormatRegEx, match => (formatTokens[match] ? formatTokens[match](date) : match));
  },

  isToday: (date, today = new Date()) => (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getYear() === today.getYear()
  ),

  addOrdinal: (day) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = day % 100;
    return day + (s[(v - 20) % 10] || s[v] || s[0]);
  },

  numDaysInMonth: (year, month) => new Date(year, month + 1, 0).getDate(),

  utcDate(dateOrTimestamp = new Date()) {
    const date = dateOrTimestamp instanceof Date ? dateOrTimestamp : new Date(dateOrTimestamp);

    return new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
  },

  isoStringToDate: (isoString) => {
    if (typeof isoString === 'string') {
      const isoParts = isoString.split('-');
      return new Date(Number(isoParts[0]), Number(isoParts[1]) - 1, Number(isoParts[2]));
    }
  },

  parseDateStampToCalDate(date = new Date()) {
    return Math.floor(new Date(date).getTime() / dayInMilliseconds);
  },

  getMonthNameByIndex: monthIndex => dateWords.MMM[monthIndex],

  getMonthFullNameByIndex: monthIndex => dateWords.MMMM[monthIndex],

  isDateWithinNextNumberOfDays(date, nextNumberOfDays, today = new Date()) {
    const testDate = new Date(date);
    const daysUntilTestDate = (testDate.getTime() - today.getTime()) / dayInMilliseconds;

    return daysUntilTestDate >= 0 && daysUntilTestDate < nextNumberOfDays;
  },

  getDaysUntilDate(date, today = new Date()) {
    const testDate = new Date(date);
    const daysUntilDate = (testDate.getTime() - today.getTime()) / dayInMilliseconds;

    return daysUntilDate;
  },

  addDays(numDays, date = new Date()) {
    date.setDate(date.getDate() + parseInt(numDays, 10));
    return date;
  },

  addMonths(numMonths, date = new Date()) {
    date.setMonth(date.getMonth() + numMonths);
    return date;
  },

  addYears(numYears, date = new Date()) {
    date.setFullYear(date.getFullYear() + numYears);
    return date;
  },

  time2Num(timeStr) {
    return Number(timeStr.replace(':', ''));
  },
};



/** WEBPACK FOOTER **
 ** ./src/utils/dates.js
 **/